export default "__VITE_ASSET__DhkU4Gz4__"